import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketFreightActivateAccountClickedEventName = 'FREIGHT_ACTIVATE_ACCOUNT_CLICKED';

export const useTrackFreightActivateAccountClicked = (): (() => void) => {
  return useCallback(() => {
    const environment = process.env.NODE_ENV ?? 'development';
    LogRocket.track(logRocketFreightActivateAccountClickedEventName, { env: environment });
  }, []);
};
